import { push } from 'connected-react-router';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { getBatchForms } from 'actions/batches';
import { hideDeleteFormModal } from './deleteFormModal';
import { getForms } from './getForms';

export const DELETE_FORM_REQUEST = 'DELETE_FORM_REQUEST';
export const DELETE_FORM_SUCCESS = 'DELETE_FORM_SUCCESS';
export const DELETE_FORM_FAILURE = 'DELETE_FORM_FAILURE';

function requestDeleteForm() {
  return {
    type: DELETE_FORM_REQUEST,
    isDeletingForm: true
  };
}

function receiveDeleteForm(deleteFormResponse) {
  return {
    type: DELETE_FORM_SUCCESS,
    isDeletingForm: false,
    deleteFormResponse
  };
}

function rejectDeleteForm() {
  return {
    type: DELETE_FORM_FAILURE,
    isDeletingForm: false
  };
}

export function deleteForm(formType, formId, pageNumber, pageSize) {
  return (dispatch) => {
    dispatch(requestDeleteForm(formId));

    const promise = () => ApiService
      .deleteForm(formType && formType.toLowerCase(), formId)
      .then((response) => {
        dispatch(receiveDeleteForm(response.data));
        dispatch(hideDeleteFormModal());
        return dispatch(getForms(pageNumber, pageSize));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectDeleteForm, true));
        }
      });
    return promise();
  };
}

export function deleteFormFromTree(formType, formId, redirectAfterDelete) {
  return (dispatch) => {
    dispatch(requestDeleteForm(formId));

    const promise = () => ApiService
      .deleteForm(formType && formType.toLowerCase(), formId)
      .then((response) => {
        dispatch(receiveDeleteForm(response.data));
        if (redirectAfterDelete) {
          dispatch(hideDeleteFormModal());
          return dispatch(push('/'));
        }
        return dispatch(hideDeleteFormModal());
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectDeleteForm, true));
        }
      });
    return promise();
  };
}

export function deleteBatchForm(batchId, batchFileId, formType, formId, pageNumber, pageSize) {
  return (dispatch) => {
    dispatch(requestDeleteForm(formId));

    const promise = () => ApiService
      .deleteForm(formType && formType.toLowerCase(), formId)
      .then((response) => {
        dispatch(receiveDeleteForm(response.data));
        dispatch(hideDeleteFormModal());
        return dispatch(getBatchForms(batchId, batchFileId, pageNumber, pageSize));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectDeleteForm, true));
        }
      });
    return promise();
  };
}
